import axios from 'axios'

const services = {
  state: {
    modal: false
  },
  mutations: {
    setModalServiceStatus (state, status) {
      state.modal = status
    }
  },
  getters: {
    getModalServiceStatus (state) {
      return state.modal
    }
  },
  actions: {
    changeModalServiceStatus (context, payload) {
      context.commit('setModalServiceStatus', payload)
    },
    retrieveDetailsServiceForm (context, payload) {
      return axios.get('/api/service/new')
    },
    retrieveDetailsService (context, payload) {
      return axios.get(`/api/service/${payload}`)
    },
    changeStateService (context, payload) {
      return axios.post('/api/service/change/', payload)
    },
    modifyService (context, payload) {
      return axios.patch('/api/service/modify/', payload)
    },
    registerService (context, payload) {
      return axios.post('/api/service/create', { service: payload })
    },
    dataServices (context, payload) {
      return axios.get('/api/data-service')
    }
  }
}

export default services



// WEBPACK FOOTER //
// app/javascript/src/store/services.js